import BaseGrid from 'components/atoms/base-grid';
import { useState } from 'react';
import { ModuleType } from 'infrastructure/enums';
import { useCheckRoleAccess } from 'infrastructure/hooks/use-check-role-access';
import { useCheckPatientModule } from 'infrastructure/hooks/patient/use-check-patient-module';
import { isRpmModule } from 'infrastructure/functions';
import { useModule } from 'infrastructure/providers/module-provider';
import FadeAnimation from 'components/atoms/base-animations/fade';

import GeneralComments from '.';
import SwitchModeButton from './switch-mode-button';

import type { GeneralCommentsMode } from '.';
import type { FC } from 'react';

interface CombinedGeneralCommentsProps {
  patientGuid: string;
  interactionStatus?: boolean;
}

const CombinedGeneralComments: FC<CombinedGeneralCommentsProps> = ({
  patientGuid,
  interactionStatus,
}) => {
  const [generalCommentsMode, setGeneralCommentsMode] =
    useState<GeneralCommentsMode>('single');
  const { module: tabModule, changeModule: setTabModule } = useModule();

  const { isReadOnlyRole } = useCheckRoleAccess();
  const { isBlockCcmModule, isBlockRpmModule } =
    useCheckPatientModule(patientGuid);

  const isSingleGCMode = generalCommentsMode === 'single';
  const blockEditing = isRpmModule(tabModule)
    ? isBlockRpmModule
    : isBlockCcmModule;

  const handleChangeMode = (mode: GeneralCommentsMode) => {
    setGeneralCommentsMode(mode);
  };

  return (
    <div id="general-comments">
      <FadeAnimation uniqueKey={isSingleGCMode.toString()}>
        <BaseGrid columns={isSingleGCMode ? 1 : 2}>
          <GeneralComments
            patientGuid={patientGuid}
            module={isSingleGCMode ? tabModule : ModuleType.RPM}
            withSwitcher={isSingleGCMode}
            interactionStatus={interactionStatus ?? false}
            switchModeButton={
              isSingleGCMode ? (
                <SwitchModeButton
                  isSingleMode={isSingleGCMode}
                  setGeneralCommentsMode={handleChangeMode}
                />
              ) : undefined
            }
            readOnly={isReadOnlyRole || blockEditing}
            mode={generalCommentsMode}
            onTabChange={setTabModule}
          />
          {!isSingleGCMode && (
            <GeneralComments
              patientGuid={patientGuid}
              module={ModuleType.CCM}
              switchModeButton={
                <SwitchModeButton
                  isSingleMode={isSingleGCMode}
                  setGeneralCommentsMode={handleChangeMode}
                />
              }
              readOnly={isReadOnlyRole || isBlockCcmModule}
              mode={generalCommentsMode}
            />
          )}
        </BaseGrid>
      </FadeAnimation>
    </div>
  );
};
export default CombinedGeneralComments;
